<section class="dxc-attachments" [class.is-over]="isOver"
  (dragenter)="onDragEnter($event)"
  (dragover)="onDragOver($event)"
  (dragleave)="onDragLeave($event)"
  (drop)="onDrop($event)">

  <header class="dxc-attachments__head">
    <span class="dxc-attachments__title">{{ title }}</span>
    @if (!loading && !isEmpty) {
      <span class="dxc-badge dxc-badge--neutral dxc-badge--count">{{ items.length }}</span>
    }
    <span class="dxc-attachments__tools"><ng-content select="[tools]"></ng-content></span>
  </header>

  <div class="dxc-attachments__body">
    @if (loading) {
      <!-- Se carga la forma del contenido, no un anillo centrado: la lista que
           llega después tiene exactamente esta silueta. -->
      <div class="dxc-attachments__list" aria-busy="true">
        @for (row of skeletonRows; track row) {
          <span class="dxc-skel dxc-attachments__skel"></span>
        }
      </div>
    } @else if (!isEmpty) {
      <ul class="dxc-attachments__list">
        @for (item of items; track item.url || item.name) {
          <li class="dxc-file-row">
            <span class="dxc-file-row__icon"><dxc-icon [name]="item.icon || itemIcon"></dxc-icon></span>

            <!-- El nombre ES el enlace, no la fila entera: una fila que fuera
                 `<button>` no podría llevar dentro el botón de quitar (R6, que
                 falla en silencio — el parser cierra el externo y los hijos que
                 siguen quedan fuera). El realce sí es de toda la fila, que la
                 primitiva deduce con `:has()`. -->
            @if (item.url) {
              <button type="button" class="dxc-file-row__body dxc-file-row__body--link" (click)="open(item)">
                <span class="dxc-file-row__name">{{ item.name }}</span>
                @if (item.meta) {
                  <span class="dxc-file-row__meta">{{ item.meta }}</span>
                }
              </button>
            } @else {
              <span class="dxc-file-row__body">
                <span class="dxc-file-row__name">{{ item.name }}</span>
                @if (item.meta) {
                  <span class="dxc-file-row__meta">{{ item.meta }}</span>
                }
              </span>
            }

            <span [class]="'dxc-badge dxc-attachments__badge dxc-badge--' + variantFor(item)">
              {{ badgeFor(item) }}
            </span>

            @if (replaceable || canRemove(item)) {
              <span class="dxc-file-row__actions">
                @if (replaceable) {
                  <button type="button" class="dxc-btn dxc-btn--ghost dxc-btn--icon dxc-btn--sm"
                    [disabled]="busy || disabled"
                    [attr.aria-label]="replaceLabel + ' ' + item.name"
                    [title]="replaceLabel"
                    (click)="replace(item)">
                    <dxc-icon name="refresh"></dxc-icon>
                  </button>
                }
                @if (canRemove(item)) {
                  <button type="button" class="dxc-btn dxc-btn--danger-ghost dxc-btn--icon dxc-btn--sm"
                    [disabled]="busy || disabled"
                    [attr.aria-label]="removeLabel + ' ' + item.name"
                    [title]="removeLabel"
                    (click)="remove(item)">
                    <dxc-icon name="trash"></dxc-icon>
                  </button>
                }
              </span>
            }
          </li>
        }
      </ul>
    } @else {
      <div class="dxc-attachments__empty">
        <dxc-state-icon [name]="emptyIcon" [size]="84"></dxc-state-icon>
        <span class="dxc-attachments__empty-title">{{ emptyTitle }}</span>
        @if (emptyHint) {
          <span class="dxc-attachments__empty-hint">{{ emptyHint }}</span>
        }
      </div>
    }
  </div>

  @if (busy) {
    <p class="dxc-attachments__busy" role="status">
      <span class="dxc-spinner" aria-hidden="true"></span>
      <span>{{ busyLabel }}</span>
    </p>
  } @else {
    <dxc-upload #upload class="dxc-attachments__drop"
      [label]="uploadLabel" [hint]="uploadHint" [icon]="uploadIcon"
      [accept]="accept" [multiple]="multiple" [compact]="compact" [disabled]="disabled"
      (filesSelected)="filesSelected.emit($event)"
      (rejected)="rejected.emit($event)"></dxc-upload>
  }

  <!-- El velo no intercepta el puntero: si lo hiciera, aparecer bajo el cursor
       dispararía el `dragleave` del panel y parpadearía. -->
  <span class="dxc-attachments__veil" aria-hidden="true">
    <span class="dxc-attachments__veil-body">
      <dxc-icon [name]="uploadIcon"></dxc-icon>
      <span>{{ dropLabel }}</span>
    </span>
  </span>
</section>
